import { HttpHeaders, HttpInterceptorFn } from '@angular/common/http';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
	const token = localStorage.getItem('token');

	// Non aggiungere il token per le API pubbliche o firmapublic
	const isPublic = req.url.includes('/api/public/') || req.url.includes('/api/firmapublic/');

	if (token && !isPublic) {
		const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
		req = req.clone({ headers });
	}

	return next(req);
};
